"use client";

import { AlertTriangle, Trash2 } from "lucide-react";
import type React from "react";

import { Button } from "@/app/_module/components/ui/button";
import {
    Dialog,
    ResponsiveDialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/app/_module/components/ui/dialog";

interface ConfirmDocumentDeleteModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    fileName: string;
    onConfirm: () => void;
}

export const ConfirmDocumentDeleteModal: React.FC<ConfirmDocumentDeleteModalProps> = function ({
    open,
    onOpenChange,
    fileName,
    onConfirm,
}) {
    const handleConfirm = () => {
        onConfirm();
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <ResponsiveDialogContent size="md">
                <DialogHeader>
                    <div className="flex items-center gap-2">
                        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
                            <AlertTriangle className="h-5 w-5 text-red-600" />
                        </div>
                        <div>
                            <DialogTitle>Delete Document</DialogTitle>
                            <DialogDescription>
                                This action cannot be undone.
                            </DialogDescription>
                        </div>
                    </div>
                </DialogHeader>
                
                <div className="py-4">
                    <p className="text-sm text-gray-600">
                        Are you sure you want to delete <span className="font-medium">"{fileName}"</span>?
                    </p>
                </div>

                <DialogFooter className="gap-2">
                    <Button
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="destructive"
                        onClick={handleConfirm}
                        className="bg-red-600 hover:bg-red-700"
                    >
                        <Trash2 className="h-4 w-4 mr-2" />
                        Delete Document
                    </Button>
                </DialogFooter>
            </ResponsiveDialogContent>
        </Dialog>
    );
};

export default ConfirmDocumentDeleteModal;
